import React, { useEffect } from "react";

import getContentById from "../../../../shared/utils/getContentById";
import _ from "lodash";
import Backgrounds from "../../_partials/Backgrounds/Index";
import TemplateBlock from "../../_partials/TemplateBlock/Index";
import prepareVideoBg from "../../../../shared/functions/prepareVideoBg";
import animationScript, {
  animationCleanUp,
} from "../../../../../animations/worldcup/table";

import assets from "./assets";
import getOptaCountryCode from "../../../../shared/utils/getOptaCountryCode";
import countries from "../../../../../language/de/countries.json";
import { useTranslation } from "react-i18next";
import Image from "../../../../shared/components/Image";
import { WcBgCircle } from "../../../../shared/backgrounds/WcBgCircle/Index";
import ProgressBar from "../../../../shared/components/ProgressBar";
import i18n from "i18next";
import { getDynamicLogoPath } from "../../../../shared/utils/functions";
import { findRankStatusChangesV2 } from "../../../../shared/functions/standing";
// import outroVideo9x16 from "../../../assets/outros/outro_playoffs_9x16.webm";

require("./style/style.scss");
require("./style/animation.scss");


const Index = (props) => {
  const refs = {
    player: React.createRef(),
    team: React.createRef(),
  };

  const {
    animation,
    data,
    images: Images,
    apiSetup,
    mode,
    format,
    isTimeline,
  } = props;

  const id = `${_.get(data, "template_name", "")}_${_.get(data, "uuid", "")}`;
  const { t } = useTranslation();

  const prepareAnimation = () => {
    prepareVideoBg({ id });
  };

  useEffect(() => {
    let animationReturn = null;
    if (mode === "animation" || mode === "video") {
      if (animation) {
        prepareAnimation();
        animationReturn = animationScript({
          refs,
          data,
          animation,
          mode,
          id,
          format,
          apiSetup,
          templateName: data?.template_name,
        });
      }
    }

    //handle outro video BEGIN
    // if(mode === "video" && !isTimeline) {
    //   const outroVideo = $(`#${id} video.outro-optional-video`);
    //   outroVideo.get(0).addEventListener("loadedmetadata", function() {
    //       const that = this;
    //       setTimeout(()=> {
    //         outroVideo?.css('opacity', 1);
    //         this.currentTime = 0;
    //         that.play();
    //       }, frontendCfg.showOutroAfter)
    //     }, false);
    // }
    //handle outro video END

    return function cleanUp() {
      if (animationReturn) {
        animationCleanUp(animationReturn);
      }
    };
  }, [animation, mode]);

  const templateData = _.get(data, "data");

  const { options, fields, dynamic } = templateData;
  const standing = _.get(dynamic, "standing");
  const backgroundImage = getMainBackground(format, _.get(dynamic, "teamSide"));
  const teamSide = getContentById("selectedSide", fields);
  const top5Players = _.get(standing, "global", []);
  const competitionId = "";
  const lng = i18n?.language;
  let previousRank = 1;
  console.log('top5Players: ', top5Players)
  return (
    <div
      id={id}
      className={`T_${_.get(data, "template_name", "")} ${animation ? "animation" : ""} side-${_.get(dynamic, "teamSide")}`}
    >
      <TemplateBlock>
        <Backgrounds bg1={backgroundImage} loop={true} />
        {/*<WcBgCircle />*/}
        <div
          className={`wc-content wc-content-v2 wc-standing-container competition-${competitionId}`}
        >
          <ProgressBar height={"8px"} strokeColor="#177C76" />
          <div className="wc-standing-header">
            <div className={"competition-positioner"}>
              <div className={"competition-logo-container"}>
                <Image
                  src={`/images/dynamic/soccer/competition/uefa-nations-league.png`}
                />
              </div>
              <div className="second-title">
              </div>
            </div>
            <div className="main-title">
              {/* {t("Standings", { keyPrefix: "templates" })} - {findGroup?.Group?.replace(
                /GROUP\s?/,
                `${t("Group", { keyPrefix: "templates" })} `
              )} */}
              {t("Top Scorer", { keyPrefix: "templates" })}
            </div>
          </div>

          <div className={"group-table"}>
            {/*<div className={'group-label green-glow'}>{findGroup?.groupName?.replace('Group', t("Group", {keyPrefix: 'templates'}))}</div>*/}
            <div className={"group-content"}>
              <div className={"table-head"}>
                <div className={"col-pos col"}></div>
                <div className={"col-team col"}></div>
                <div className={"col-diff col"}>
                  {/* {t("GD", { keyPrefix: "table" })} */}
                  {t("Goals", { keyPrefix: "table" })}
                </div>
                <div className={"col-diff col"}>
                  {/* {t("PTS", { keyPrefix: "table" })} */}
                  {t("Assists", { keyPrefix: "table" })}
                </div>
                <div className={"col-pkt col"}>
                  {t("Total")}
                </div>
              </div>
              {top5Players?.map((entry, index, arr) => {
                const playerName = entry?.PlayerAlias ? entry?.PlayerAlias : entry?.PlayerFirstName ? entry?.PlayerFirstName + ' ' + entry?.PlayerLastName : entry?.PlayerlastName;
                let rank = 1;

                if (
                  index > 0 &&
                  entry.ShotsAtGoalSuccessfull === arr[index - 1].ShotsAtGoalSuccessfull &&
                  entry.Assists === arr[index - 1].Assists
                ) {
                  rank = previousRank; // same rank as previous
                } else if (index > 0) {
                  rank = previousRank + 1; // Next dense rank
                  previousRank = rank;
                }
                return (
                  <div
                    key={"table-" + index}
                    className={`table-row`}
                  >
                    <div className={"col-pos col"}>{rank}.</div>
                    <div className={"col-team col"}>
                      <div className={"col-logo"}>
                        <Image
                          className="team-logo"
                          src={getDynamicLogoPath({
                            team: {
                              TeamId: entry?.TeamId,
                              TeamName: entry?.TeamName,
                              ThreeLetterCode: entry?.teamThreeLetterCode
                            },
                            competitionId,
                          })}
                        />
                      </div>
                      {playerName}
                    </div>
                    <div className={"col-diff col"}>{entry.ShotsAtGoalSuccessfull}</div>
                    <div className={"col-diff col"}>{entry.Assists}</div>
                    <div className={"col-pkt col"}>{Number(entry.Assists) + Number(entry.ShotsAtGoalSuccessfull)}</div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </TemplateBlock>
    </div>
  );
};

const getMainBackground = (format, side) => {
  return _.get(assets, `sd_background_1920`);
};

export default Index;
